<template>
    <div class="segments">
        <span
            v-for="index in total"
            :key="index"
            class="segment"
            :class="{
                'is-done': index < current,
                'is-active': index === current,
            }"></span>

        <!-- The segments carry no text, so the position is stated outright rather
             than left to a progressbar's percentage. -->
        <span class="sr-only">{{ t("onboarding.calendarFirst.progress.position", { current, total }) }}</span>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineProps<{ total: number; current: number }>();

const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .segments {
        @apply inline-flex items-center gap-2 rounded-full border border-border bg-surface-raised px-3 py-2;
    }

    .segment {
        @apply h-2 w-9 rounded-full bg-border transition-[width,background-color] duration-500 motion-reduce:transition-none;
    }

    .segment.is-done {
        @apply w-9 bg-accent;
    }

    /* The in-progress segment is a shorter stub, so "where I am" reads differently
       from "what I finished" without relying on colour alone. */
    .segment.is-active {
        @apply w-5 bg-accent;
    }
}
</style>
